/* ============================================
   KIT ACCORDION - THEORIC
   Parses ## delimited text into reactive accordion
   Only one panel open at a time
   ============================================ */

(function () {
  'use strict';

  document.querySelectorAll('.kit-accordion').forEach(function (container) {
    var dataEl = container.querySelector('.kit-accordion__data');
    if (!dataEl) return;

    var rawText;
    try {
      rawText = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!rawText || !rawText.trim()) return;

    // Normalize HTML from dynamic sources (metafields) to plain text
    rawText = rawText
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/p>\s*<p[^>]*>/gi, '\n')
      .replace(/<\/p>/gi, '\n')
      .replace(/<li[^>]*>/gi, '\n* ')
      .replace(/<\/li>/gi, '\n')
      .replace(/<\/(?:ul|ol|div|h[1-6]|blockquote)>/gi, '\n')
      .replace(/<[^>]+>/g, '')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'");

    // Split by ## and filter empty segments
    var sections = rawText.split('##').filter(function (s) {
      return s.trim().length > 0;
    });

    if (sections.length === 0) return;

    // Build accordion HTML
    var accordionHTML = sections.map(function (section, index) {
      var trimmed = section.trim();

      // Extract title: first line, or text before first period if single-line
      var firstNewline = trimmed.indexOf('\n');
      var title, contentText;

      if (firstNewline > -1) {
        title = trimmed.substring(0, firstNewline).trim();
        contentText = trimmed.substring(firstNewline + 1).trim();
      } else {
        // Single line — try to split at first '. '
        var dotPos = trimmed.indexOf('. ');
        if (dotPos > -1 && dotPos < 80) {
          title = trimmed.substring(0, dotPos).trim();
          contentText = trimmed.substring(dotPos + 2).trim();
        } else {
          title = trimmed;
          contentText = '';
        }
      }

      // Remove trailing colon from title for cleaner display
      title = title.replace(/:$/, '').trim();

      // Parse content lines into HTML
      var contentHTML = parseContent(contentText);
      var startClosed = container.getAttribute('data-start-closed') === 'true';
      var isFirst = index === 0 && !startClosed;
      var num = String(index + 1).padStart(2, '0');

      return (
        '<div class="kit-accordion__item' + (isFirst ? ' is-open' : '') + '" data-kit-item>' +
          '<button class="kit-accordion__trigger" data-kit-trigger aria-expanded="' + isFirst + '">' +
            '<span class="kit-accordion__index">' + num + '</span>' +
            '<span class="kit-accordion__title">' + escapeHTML(title) + '</span>' +
            '<span class="kit-accordion__icon">' +
              '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
                '<path class="kit-accordion__icon-v" d="M12 5v14"/>' +
                '<path d="M5 12h14"/>' +
              '</svg>' +
            '</span>' +
          '</button>' +
          '<div class="kit-accordion__content" data-kit-content>' +
            '<div class="kit-accordion__content-inner">' +
              contentHTML +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    container.innerHTML = '<div class="kit-accordion__wrapper">' + accordionHTML + '</div>';

    // --- Interaction: single-open accordion ---
    var triggers = container.querySelectorAll('[data-kit-trigger]');
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('[data-kit-item]');
        var isOpen = item.classList.contains('is-open');
        var content = item.querySelector('[data-kit-content]');

        // Close all items
        container.querySelectorAll('[data-kit-item]').forEach(function (other) {
          var otherContent = other.querySelector('[data-kit-content]');
          var otherTrigger = other.querySelector('[data-kit-trigger]');
          other.classList.remove('is-open');
          otherTrigger.setAttribute('aria-expanded', 'false');
          otherContent.style.maxHeight = '0';
        });

        // If was closed, open this one
        if (!isOpen) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    });

    // Set initial state: first item open
    var firstContent = container.querySelector('[data-kit-item].is-open [data-kit-content]');
    if (firstContent) {
      firstContent.style.maxHeight = firstContent.scrollHeight + 'px';
    }
  });

  /**
   * Parse content text into formatted HTML
   * Handles: paragraphs, bullet lists (* or -), subtitles
   */
  function parseContent(text) {
    if (!text) return '';

    var lines = text.split('\n');
    var html = '';
    var inList = false;

    lines.forEach(function (line) {
      var trimmed = line.trim();
      if (!trimmed) return;

      // Bullet list item
      if (trimmed.charAt(0) === '*' || trimmed.charAt(0) === '-') {
        var bulletText = trimmed.replace(/^[\*\-]\s*/, '');
        if (!bulletText) return;

        if (!inList) {
          html += '<ul class="kit-accordion__list">';
          inList = true;
        }
        html += '<li>' + escapeHTML(bulletText) + '</li>';
      } else {
        // Close list if we were in one
        if (inList) {
          html += '</ul>';
          inList = false;
        }

        // Subtitle detection:
        // - Ends with ':' (e.g., "Indicado para:")
        // - Short line without period at end (e.g., "Ativos principais")
        var isSubtitle = false;
        if (trimmed.endsWith(':')) {
          isSubtitle = true;
        } else if (trimmed.length < 35 && !trimmed.endsWith('.') && !trimmed.endsWith(')')) {
          isSubtitle = true;
        }

        if (isSubtitle) {
          html += '<h4 class="kit-accordion__subtitle">' + escapeHTML(trimmed) + '</h4>';
        } else {
          html += '<p>' + escapeHTML(trimmed) + '</p>';
        }
      }
    });

    if (inList) {
      html += '</ul>';
    }

    return html;
  }

  function escapeHTML(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }
})();
